import { BrButton, BrDivider } from '@govbr-ds/react-components';
import { useNavigate } from 'react-router-dom';
import { useContext, useEffect } from 'react';
import { DiefCfemContext } from '../contexts/DiefCfemContext';
import { ICrumb } from '../interfaces/ICrumb';
import TituloSection from '../components/tituloSection/tituloSection';
import { useAuth } from 'hooks/useAuth';
import DiefCfemCards from './components/diefCfemCards/diefCfemCards';
import styles from './DiefCfem.module.scss';
import CustomLoading from 'components/customLoading/customLoading';

function DiefCfem() {
  const auth = useAuth();
  const navigate = useNavigate();
  const context = useContext(DiefCfemContext);

  useEffect(() => {
    const crumbs: ICrumb[] = [
      {
        isHome: true,
        label: 'home',
        onClick: () => {
          navigate('/');
        },
      },
    ];
    context?.setCrumbs(crumbs);
    sessionStorage.setItem('anoDeclaracao', new Date().getFullYear().toString());
    sessionStorage.setItem('mesDeclaracao', '-1');
  }, []);

  useEffect(() => {
    if (auth.isLoading === false && auth.isAuthenticated === false) {
      auth.login();
    }
  }, [auth.isAuthenticated, auth.isLoading]);

  if (auth.isAuthenticated) {
    return (
      <>
        <BrDivider />
        <TituloSection />
        <DiefCfemCards />
      </>
    );
  } else {
    return (
      <div className={styles.container}>
        <CustomLoading label='Redirecionando para a tela de Login. Clique no botão abaixo para ser redirecionado imediatamente.'>
          <BrButton secondary onClick={() => auth.login()}>
            Login
          </BrButton>
        </CustomLoading>
      </div>
    );
  }
}

export default DiefCfem;
